module.exports = __webpack_public_path__ + "img/escalier_marche_1.22fe5373.svg";